import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';

import { Button as Btn } from 'components';
import { Image, Dropdown, Popup, Grid } from 'semantic-ui-react';
import { Tooltip } from 'material-ui';

import classNames from 'classnames/bind';
import styles from './AdminLicenseList.css';
const cx = classNames.bind(styles);

class AdminLicenseFilter extends Component {
  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { handleInitFilter, filterClose, cancleCheck, executeFilter, paramData, filters, tempFilter, popupOpen, handlePopup } = this.props;

    // 라이센스 상태 필터
    const status = [
      { '-1': defineMessages(formatMessage({ id: 'AdminLicenseList_9', defaultMessage: '미존재' })) },
      { 0: defineMessages(formatMessage({ id: 'AdminLicenseList_10', defaultMessage: '신청' })) },
      { 1: defineMessages(formatMessage({ id: 'AdminLicenseList_11', defaultMessage: '사용중' })) },
      { 2: defineMessages(formatMessage({ id: 'AdminLicenseList_12', defaultMessage: '사용대기' })) },
      { 3: defineMessages(formatMessage({ id: 'AdminLicenseList_13', defaultMessage: '만료' })) },
      { 10: defineMessages(formatMessage({ id: 'AdminLicenseList_14', defaultMessage: '신청취소' })) }
    ];

    // 라이센스 상태 필터
    const licenseType = [
      { 1: defineMessages(formatMessage({ id: 'LicenseEdit_24', defaultMessage: '영구 라이센스' })) },
      { 2: defineMessages(formatMessage({ id: 'LicenseEdit_25', defaultMessage: '기간 라이센스' })) },
      { 4: defineMessages(formatMessage({ id: 'LicenseEdit_26', defaultMessage: '횟수 라이센스' })) }
    ];

    const statusFilterOptions = (
      <Dropdown.Menu>
        <Dropdown.Header
          content={defineMessages(formatMessage({ id: 'AdminLicenseList_8', defaultMessage: '상태' }))}
        />
        {status.map((data, index) => {
          return (
            <Dropdown.Item
              key={index}
              value={Object.keys(data)[0]}
              onClick={(e, props) => {
                e.stopPropagation();
                filters.statusFilter(props);
              }}>
              <div className={cx('check-box')}>
                <Image
                  className={
                    !!tempFilter['statusArray'] &&
                      tempFilter['statusArray'].findIndex(f => f === Object.keys(data)[0]) !== -1
                      ? 'checkmark box'
                      : 'outline box'
                  }
                  src="/img/target/ico-check.png"
                />
              </div>
              <div className={cx('box-text')}>{data[Object.keys(data)[0]]}</div>
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    );

    const licenseTypeFilterOptions = (
      <Dropdown.Menu>
        <Dropdown.Header
          content={defineMessages(formatMessage({ id: 'LicenseEdit_23', defaultMessage: '라이센스 타입' }))}
        />
        {licenseType.map((data, index) => {
          return (
            <Dropdown.Item
              key={index}
              value={Object.keys(data)[0]}
              onClick={(e, props) => {
                e.stopPropagation();
                filters.licenseTypeFilter(props);
              }}>
              <div className={cx('check-box')}>
                <Image
                  className={
                    !!tempFilter['licenseType'] && Object.keys(data)[0] & tempFilter['licenseType']
                      ? 'checkmark box'
                      : 'outline box'
                  }
                  src="/img/target/ico-check.png"
                />
              </div>
              <div className={cx('box-text')}>{Object.values(data)[0]}</div>
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    );

    let statusArray = paramData.getIn(['filter', 'statusArray']) && paramData.getIn(['filter', 'statusArray']).toJS();

    if (statusArray === undefined) {
      statusArray = [];
    }

    const licenseTypeObj = paramData.getIn(['filter', 'licenseType']);
    let licenseTypeLength = null;

    if (licenseTypeObj === 1 || licenseTypeObj === 2 || licenseTypeObj === 4) {
      licenseTypeLength = 1;
    } else if (licenseTypeObj === 3 || licenseTypeObj === 5 || licenseTypeObj === 6) {
      licenseTypeLength = 2;
    } else if (licenseTypeObj === 7) {
      licenseTypeLength = 3;
    }

    const totalArrayLength = statusArray.length + licenseTypeLength;
    const templateStatus = [];
    if (statusArray.length > 0) {
      statusArray.map((isServiceTemplate, index) => {
        const statusArray =
          paramData.getIn(['filter', 'statusArray']) && paramData.getIn(['filter', 'statusArray']).toJS();
        if (statusArray[index] === '-1') {
          templateStatus.push(defineMessages(formatMessage({ id: 'AdminLicenseList_9', defaultMessage: '미존재' })));
        } else if (statusArray[index] === '0') {
          templateStatus.push(defineMessages(formatMessage({ id: 'AdminLicenseList_10', defaultMessage: '신청' })));
        } else if (statusArray[index] === '1') {
          templateStatus.push(defineMessages(formatMessage({ id: 'AdminLicenseList_11', defaultMessage: '사용중' })));
        } else if (statusArray[index] === '2') {
          templateStatus.push(defineMessages(formatMessage({ id: 'AdminLicenseList_12', defaultMessage: '사용대기' })));
        } else if (statusArray[index] === '3') {
          templateStatus.push(defineMessages(formatMessage({ id: 'AdminLicenseList_13', defaultMessage: '만료' })));
        } else if (statusArray[index] === '10') {
          templateStatus.push(defineMessages(formatMessage({ id: 'AdminLicenseList_14', defaultMessage: '신청취소' })));
        }
      });
    }
    const licenseConfirm = [];
    if (licenseTypeLength > 0) {
      licenseType.map((data, index) => {
        const checkNumber = Object.keys(data)[0];
        const bit = Object.keys(data)[0] & tempFilter['licenseType'];
        const permenant = defineMessages(formatMessage({ id: 'LicenseEdit_24', defaultMessage: '영구 라이센스' }));
        const period = defineMessages(formatMessage({ id: 'LicenseEdit_25', defaultMessage: '기간 라이센스' }));
        const times = defineMessages(formatMessage({ id: 'LicenseEdit_26', defaultMessage: '횟수 라이센스' }));
        if (checkNumber === '1' && bit) {
          licenseConfirm.push(permenant);
        } else if (checkNumber === '2' && bit) {
          licenseConfirm.push(period);
        } else if (checkNumber === '4' && bit) {
          licenseConfirm.push(times);
        }
      });
    }

    // 툴팁 정보
    const tooltipInfo = (
      <div className={cx('tooltip-wrapper')}>
        <div className={cx('arrow')} />
        {licenseTypeLength > 0 && (
          <div className={cx('tooltip-row')}>
            <div className={cx('tooltip-title')}>
              <span className={cx('title-dot')} />
              {defineMessages(formatMessage({ id: 'LicenseEdit_23', defaultMessage: '라이센스 타입' }))}
            </div>
            <span className={cx('tooltip-context')}>{licenseConfirm.join(', ')}</span>
          </div>
        )}
        {statusArray.length > 0 && (
          <div className={cx('tooltip-row')}>
            <div className={cx('tooltip-title')}>
              <span className={cx('title-dot')} />
              {defineMessages(formatMessage({ id: 'AdminLicenseList_8', defaultMessage: '상태' }))}
            </div>
            <span className={cx('tooltip-context')}>{templateStatus.join(', ')}</span>
          </div>
        )}
      </div>
    );

    return (
      <Tooltip
        classes={{
          tooltip: 'tooltip',
          tooltipOpen: totalArrayLength > 0 ? '' : 'close'
        }}
        title={tooltipInfo}
        placement="bottom">
        <div className={cx('target-dropdown-area', totalArrayLength > 0 ? 'target-dropdown-area-border' : '')}>
          <div className={cx('dropdown-arrow-area', 'table-filter-arrow')}>
            {totalArrayLength > 0 ? (
              <div className={cx('number-box')}>{totalArrayLength}</div>
            ) : (
                <Image className={cx('dropdown-image')} src="/img/table/selectbox_number_arrow.png" />
              )}
          </div>
          <Popup
            className={cx('filter-popup')}
            trigger={
              <div className={cx('default-text', totalArrayLength > 0 ? 'filter-length' : '')}>
                {defineMessages(formatMessage({ id: 'ExamTemplateList_35', defaultMessage: '필터' }))}
              </div>
            }
            open={popupOpen}
            onOpen={() => handlePopup(true)}
            onClose={() => { filterClose(), handlePopup(false) }}
            on="click"
            flowing
            position="bottom center">
            <Grid centered divided columns={2}>
              <Grid.Column textAlign="left">{licenseTypeFilterOptions}</Grid.Column>
              <Grid.Column textAlign="left">{statusFilterOptions}</Grid.Column>
            </Grid>
            <Grid className={cx('bottom-options display-block')}>
              <Grid.Column>
                <div className={cx('all-check-off')} onClick={handleInitFilter}>
                  {defineMessages(formatMessage({ id: 'Target_32', defaultMessage: '모든 필터 해제' }))}
                </div>
                <div className={cx('inline-block')}>
                  <Btn className={cx('button-border', 'button')} onClick={() => { cancleCheck(), handlePopup(false) }}>
                    {defineMessages(formatMessage({ id: 'TargetDetail_7', defaultMessage: '취 소' }))}
                  </Btn>
                  <Btn
                    className={cx('button-brand', 'button')}
                    // loading={editOnProgress}
                    // disabled={disableSave && (editInvalid || editOnProgress)}
                    onClick={() => { executeFilter(), handlePopup(false) }}>
                    {defineMessages(formatMessage({ id: 'TargetDetail_37', defaultMessage: '확 인' }))}
                  </Btn>
                </div>
              </Grid.Column>
            </Grid>
          </Popup>
        </div>
      </Tooltip>
    );
  }
}

export default injectIntl(AdminLicenseFilter);



// WEBPACK FOOTER //
// ./src/script/components/admin/license/AdminLicenseFilter.js